import { defineComponent, onMounted, Ref, ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';
import { LangTypes, getWcLocalesPromiseArr, isRTLLangue, Locale2WcUiLangMap } from './utils';
import { createLogger } from '@tt4b/ttam-utils';

import '@byted/wc-business-ui/dist/wc-business-ui/wc-business-ui.css';
  // @ts-ignore
import { BytedWcBusinessConfigProvider, BytedWcConfigProvider } from '@byted/wc-business-ui/dist/components';
if (!customElements.get('wc-provider-vertical')) {
  customElements.define('wc-provider-vertical', BytedWcConfigProvider);
}
if (!customElements.get('wc-b-provider-vertical')) {
  // @ts-ignore
  customElements.define('wc-b-provider-vertical', BytedWcBusinessConfigProvider);
}

const webcomponentsLogger = createLogger('Webcomponents');

export default defineComponent({
  name: 'WcUiConfig',
  setup(prop, { emit }) {
    const wcConfigProps: Ref<{
      direction?: 'rtl' | 'ltr';
      locale?: any;
    }> = ref({});
    const wcBusinessConfigProps: Ref<{
      direction?: 'rtl' | 'ltr';
      locale?: any;
    }> = ref({});

    const fetchWcUiLang = async (lang: LangTypes) => {
      // 如果无 match 语言的异常，使用组件库兜底语言
      if (!Locale2WcUiLangMap[lang]) {
        emit('finished');

        return;
      }
      try {
        const [{ default: WcBusinessUiLocales }] = await Promise.all(getWcLocalesPromiseArr(lang));
        const direction = isRTLLangue() ? 'rtl' : 'ltr';
        wcConfigProps.value = {
          direction,
        };
        // console.log(WcBusinessUiLocales, 'WcBusinessUiLocales');
        wcBusinessConfigProps.value = {
          locale: WcBusinessUiLocales,
          direction,
        };
        emit('finished');
      } catch (error) {
        // console.log(error);
        webcomponentsLogger.error('fetch webcomponents langs failed', JSON.stringify(error));
        emit('finished');
      }
    };

    onMounted(() => {
      fetchWcUiLang((i18n.locale || 'en') as LangTypes);
    });

    return {
      wcConfigProps,
      wcBusinessConfigProps,
    };
  },
});
